module.exports = __webpack_public_path__ + "static/media/daniela.c43a7567.png";